import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/claimer.png'


const _hoisted_1 = { class: "p-10" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Pls connect (burner) wallet", -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { className: "w-full text-center pb-10 relative" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  className: "inline-block",
  src: _imports_0,
  alt: "claim and info box"
}, null, -1)
const _hoisted_7 = {
  className: "absolute",
  style: {"top":"75px","width":"365px","text-align":"left","left":"0px","right":"0px","margin-left":"auto","margin-right":"auto"}
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-full mb-5 text-center" }, " Farmer account not found :( Create a new one? ", -1)
const _hoisted_11 = { class: "w-full text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_Vault = _resolveComponent("Vault")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.wallet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_ConfigPane),
          _hoisted_3
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", {
              class: "absolute h-[196px] w-1/2 right-0 cursor-pointer",
              style: {"top":"0px","right":"0px","bottom":"0px","width":"50%","height":"196px"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.claim && _ctx.claim(...args)))
            }),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h4", null, _toDisplayString(((_ctx.gemStaked / 5000) * 100).toFixed(2)) + "% Staked", 1),
              _createElementVNode("h4", null, "(" + _toDisplayString(_ctx.gemStaked) + " / 5000)", 1)
            ])
          ]),
          (_ctx.farmerAcc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(), _createBlock(_component_Vault, {
                  key: _ctx.farmerAcc,
                  class: "mb-10",
                  vault: _ctx.farmerAcc.vault.toBase58(),
                  onSelectedWalletNft: _ctx.handleNewSelectedNFT
                }, {
                  default: _withCtx(() => [
                    (_ctx.farmerState === 'staked' && _ctx.selectedNFTs.length > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "mr-5 nes-btn is-primary",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addGems && _ctx.addGems(...args)))
                        }, " Add Gems (resets staking) "))
                      : _createCommentVNode("", true),
                    (_ctx.farmerState === 'unstaked')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          style: {"background":"#55fd00","padding":"10px 20px","width":"100%","font-weight":"bold","color":"#000","border-radius":"10px"},
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.beginStaking && _ctx.beginStaking(...args)))
                        }, " Begin staking (Move all nft to be staked an hit begin staking) "))
                      : _createCommentVNode("", true),
                    (_ctx.farmerState === 'staked')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          style: {"background":"#8f0048","padding":"10px 20px","width":"100%","font-weight":"bold","color":"#fff","border-radius":"10px"},
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                        }, " End staking "))
                      : _createCommentVNode("", true),
                    (_ctx.farmerState === 'pendingCooldown')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          style: {"background":"#8f0048","padding":"10px 20px","width":"100%","font-weight":"bold","color":"#fff","border-radius":"10px"},
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                        }, " End cooldown "))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["vault", "onSelectedWalletNft"]))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "nes-btn is-primary",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                  }, " New Farmer ")
                ])
              ]))
        ]))
  ]))
}